import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlatiBlocariAutoComponent } from './plati-blocari-auto.component';

import { PlatiBlocariAutoRoutingModule } from './plati-blocari-auto-routing.module'

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ToastrModule } from 'ngx-toastr';
import { NgxLoadingModule } from 'ngx-loading';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@NgModule({
    declarations: [
        PlatiBlocariAutoComponent
    ],
    imports: [
        CommonModule,
        PlatiBlocariAutoRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        ToastrModule,
        NgxLoadingModule,
        MatAutocompleteModule
    ]
})
export class PlatiBlocariAutoModule { }
